export const founders = [
  {
    image: "/images/kevin.jpg",
    name: "Kevin Wang",
    university: "UC Irvine",
    summary: "Youth tennis coach with experience mentoring and tutoring refugee students.",
    role: "President, Director of Business Development, Coach",
    description:
      "Kevin Wang studies at UC Irvine, majoring in Neurobiology. His passion for mentorship and community service began in high school when he contributed to the development of 1must, a nonprofit organization dedicated to tutoring refugee students. Combining his love for tennis with his experience as a youth tennis coach, Kevin is excited to embark on his new journey with Project Breakpoint, where he aims to inspire others and make a meaningful impact through the sport he loves.",
  },
  {
    image: "/images/kyle.jpg",
    name: "Kyle Villeponteau",
    university: "UC Santa Barbara",
    summary: "Club tennis player and former summer-camp instructor who shares his coaching experience.",
    role: "Vice President, CTO, Coach",
    description:
      "Kyle Villeponteau studies Computer Science at UC Santa Barbara. His passion for tennis started as a little kid and continued throughout high school as he managed to rank top 250 in his class of graduates. He now plays competitive club tennis at UCSB. Beyond competition, Kyle's love for the sport deepened when he took on the role of a tennis instructor at Bay Club summer camp. Through Project Breakpoint, he aims to share his enthusiasm for tennis and mentorship, inspiring and empowering young children to discover the joy of the game.",
  },
  {
    image: "/images/ian.jpg",
    name: "Ian Lucchesi",
    university: "UC Irvine",
    summary: "Brings experience guiding younger students and coaching children in gymnastics.",
    role: "Secretary",
    description:
      "Ian Lucchesi studies at UC Irvine, majoring in Neurobiology. His desire for leadership and the opportunity to teach stems from his time in high school with the Big Brother Program, teaching incoming freshmen the ropes and contributing to their transition. Coming from a background of coaching kids in gymnastics, Ian is excited to make meaningful differences and spread joy through sports and fitness with Project Breakpoint.",
  },
  {
    image: "/images/quyen.jpg",
    name: "Quyen Ho",
    university: "UC Irvine",
    summary: "Combines youth tutoring experience with a love for tennis and active play.",
    role: "Director of Outreach, Assistant Coach",
    description:
      "Quyen Ho studies at UC Irvine majoring in Biological Sciences. Her passion for youth mentorship began in high school when she tutored students to help them develop their writing skills. Being part of the tennis team in high school provided her with a community she hopes other students can experience as well, which is why she is excited to join Project Breakpoint. She hopes to give youth in her community an opportunity to be physically active in a way that's fun and engaging.",
  },
  {
    image: "/images/arjun.jpg",
    name: "Arjun",
    university: "UC Irvine",
    summary: "Brings competitive tennis and assistant coaching experience from the City of Irvine.",
    role: "Head of Marketing",
    description:
      "Arjun studies at UC Irvine majoring in Applied Mathematics. His passion for leadership stems from his experience as president of his middle and high school student government. With over 10 years of competitive tennis experience, four years of assistant coaching at the City of Irvine during the summers, and service as varsity tennis captain in high school, Arjun is excited to share his love for the sport and help others find joy in the game.",
  },
  {
    image: "/images/tiana.jpg",
    name: "Tiana Tran",
    university: "UC Irvine",
    summary: "Draws on experience mentoring high school students and tutoring younger children.",
    role: "Community Outreach",
    description:
      "Tiana Tran studies at UC Irvine, majoring in Public Health Sciences. Her passion for tennis and commitment to community service align closely with Project Breakpoint’s mission. With experience mentoring high school students and tutoring younger children, Tiana is eager to share her enthusiasm for tennis with others. As a former high school tennis player, she aims to introduce the sport to youth in an engaging and accessible way, with the goal of fostering a positive and lasting impact within the community."
  }
];
